import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/paz-corporate/components/Yellow/Yellow.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@apollo+experimental-nextjs-app-support@0.6.0_@apollo+client@3.8.8_graphql@16.11.0_react-dom@_kpgannxjlbn4h65425vdmgcsrq/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@apollo+experimental-nextjs-app-support@0.6.0_@apollo+client@3.8.8_graphql@16.11.0_react-dom@_kpgannxjlbn4h65425vdmgcsrq/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/packages/apollo/apollo-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/LoadingSkeletonPage/LoadingSkeletonPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useKeyboardNavigation"] */ "/app/packages/utils/useKeyboardNavigation.tsx");
